import { App } from "./App";
import { ControllerRegistry } from "../Registry/ControllerRegistry";
import type { AppMenu } from "../Controller/HTML/AppMenu";
import { toMap } from "../../../HA";

export class Menu extends App {

    public clear() {
        this.getMenu().clear();
    }

    public addItem(data: Map<string, any>) {
        this.getMenu().addItem(data);
    }

    // Type-only import de AppMenu (effacé au build) → aucun import-valeur du
    // Controller, donc pas de cycle Entity ↔ Controller. L'instanciation passe
    // par le registre (ha/441j).
    protected getMenu(): AppMenu {
        return this.get("menu");
    }

    /**
     *
     * @param data
     */
    protected initialize(data: any) {
        const d = toMap(data) as Map<string, any>;
        d.set("navigable", false);
        super.initialize(d);
        this.addToData("menu", ControllerRegistry.create("AppMenu", d) as AppMenu);
    }

    protected createTag() {
        return;
    }
}
